export type TableTranslations = {
  content: {
    actionOnSelected: {
      actionOnSelected: string;
      archive: string;
      delete: string;
      duplicate: string;
    };
    button: {
      resetForm: string;
      submitSearch: string;
    };
    maxRows: string;
    nextPage: string;
    noResults: string;
    of: string;
    previousPage: string;
  };
};

export const tableTranslations: TableTranslations = {
  content: {
    actionOnSelected: {
      actionOnSelected: 'Action on selected',
      archive: 'Archive',
      delete: 'Delete',
      duplicate: 'Duplicate',
    },
    button: {
      resetForm: 'Reset',
      submitSearch: 'Search',
    },
    maxRows: 'Max rows',
    nextPage: 'Next page',
    noResults: 'No results',
    of: 'of',
    previousPage: 'Previous page',
  },
};
